import { z } from 'zod';
import {
    CardPointeSurchargePostalStatus,
    CardPointeSurchargeTokenType,
    type CardPointeSurchargeResponseBody,
} from '../../../types/ipg/cardpointe/cardpointe-surcharge.types';

export const CardPointeSurchargeResponseBodySchema: z.ZodType<CardPointeSurchargeResponseBody> = z
    .object({
        token: z.enum(CardPointeSurchargeTokenType),
        postal: z.enum(CardPointeSurchargePostalStatus),
        fee_amount: z
            .string()
            .regex(/^\d+(?:\.\d{2})?$/)
            .optional(),
    })
    .loose();
